import React, { useState, useMemo } from 'react';

import moment from 'moment';

import { Report } from '~/components';
import { DateTime, Input, Select, RadioGroup } from '~/components/Form';
import { PesquisaTabela } from '~/components/Form/v2';
import { t } from '~/helpers';

function RelInstalacaoPin() {
  const [open, setOpen] = useState(true);

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });
  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  const cellsCompany = useMemo(
    () => [
      {
        id: 'idempresaveiculo',
        label: t('s.cadastro.empresaveiculo.idempresaveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeempresaveiculo',
        label: t('s.cadastro.empresaveiculo.nomeempresaveiculo'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const cellsModelVehicle = useMemo(
    () => [
      {
        id: 'idmodeloveiculo',
        label: t('s.cadastro.modeloveiculo.codigoauxiliarmodeloveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomemarcaveiculo',
        label: t('s.cadastro.modeloveiculo.nomemarcaveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomemodeloveiculo',
        label: t('s.cadastro.modeloveiculo.nomemodeloveiculo'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const cellsVehicle = useMemo(
    () => [
      {
        id: 'idveiculo',
        label: t('s.configuracao.comboio.idveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'placaveiculo',
        label: t('s.cadastro.veiculo.placaveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomemodeloveiculo',
        label: t('s.menu.cadastro.veiculo.modelo'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const cellsDescription = useMemo(
    () => [
      {
        id: 'descricaodispositivoinstalacaodvec',
        label: t('s.cadastro.modeloveiculo.descricao'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const orderoptions = [
    { value: 'LI', label: t('s.relatorio.abastecimento.opcaolistagem') },
    { value: 'DT', label: t('s.relatorio.abastecimento.opcaodata') },
    { value: 'MD', label: t('s.operacao.abastecimento.nomemodeloveiculo') },
    { value: 'EM', label: t('s.relatorio.abastecimento.opcaoempresa') },
    { value: 'DP', label: t('s.menu.configuracao.dispositivoinstalacaodvec') },
  ];

  function handleSerializeForm(params) {
    return {
      ...params,
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.menu.configuracao.dispositivoinstalacaodvec')}
      relatorio="relinstalacaopin"
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
        tipoordenacaoreport: 'LI',
      }}
    >
      <DateTime
        label={t('s.geral.opcoes.datahorainicial')}
        name="datahorainicial"
        serialize={(value) =>
          value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <DateTime
        label={t('s.geral.opcoes.datahorafinal')}
        name="datahorafinal"
        serialize={(value) =>
          value.set({ seconds: 59 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <PesquisaTabela
        name="idveiculo"
        label={t('s.menu.cadastro.veiculo')}
        primary="idveiculo"
        secondary="nomemodeloveiculo"
        url="veiculos"
        header={cellsVehicle}
      />

      <PesquisaTabela
        name="idmodeloveiculo"
        label={t('s.menu.cadastro.veiculo.modelo')}
        primary="idmodeloveiculo"
        secondary="nomemodelomarcamodeloveiculo"
        url="modelosveiculos"
        header={cellsModelVehicle}
      />

      <PesquisaTabela
        name="idempresaveiculo"
        label={t('s.menu.cadastro.veiculo.empresa')}
        primary="idempresaveiculo"
        secondary="nomeempresaveiculo"
        url="empresasveiculos"
        header={cellsCompany}
      />

      <PesquisaTabela
        name="iddispositivoinstalacaodvec"
        label={t('s.menu.configuracao.dispositivoinstalacaodvec')}
        primary="iddispositivoinstalacaodvec"
        secondary="descricaodispositivoinstalacaodvec"
        url="dispositivosinstalacoesdvecs"
        header={cellsDescription}
      />

      <Select
        name="tipoordenacaoreport"
        variant="outlined"
        size="small"
        label={t('s.relatorio.abastecimento.tipoordenacao')}
        options={orderoptions}
      />

      <Input name="idinstalacaopin" label={t('s.geral.codigoinstalacao')} />

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default RelInstalacaoPin;
